"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBSearchUIBar;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _Search = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Search.svg"));
var _Close = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Close.svg"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable */

function SVBSearchUIBar(props) {
  const {
    onsearchTermChange,
    handleSubmit,
    removeSelectedFilter,
    onClear,
    placeHolderData,
    filterType
  } = props;
  const [filterTypeBool, setFilterTypeBool] = (0, _react.useState)(true);
  const [showClear, setShowClear] = (0, _react.useState)(false);
  const [selectedCategory, setSelectedCategory] = (0, _react.useState)(filterType || '');
  /* istanbul ignore next */
  const clearFilterType = () => {
    setFilterTypeBool(false);
    setSelectedCategory('');
    removeSelectedFilter();
  };
  /* istanbul ignore next */
  const onsearchInputChange = (e, selectedCategory) => {
    var _e$target;
    //check if clear should be visible only if there is input
    if (((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value.length) > 0) {
      setShowClear(true);
    } else {
      setShowClear(false);
    }
    //callback to parent to return back values
    onsearchTermChange(e, selectedCategory);
  };
  //clear search input on click and make it not visible
  /* istanbul ignore next */
  const clearSearchInput = () => {
    setTimeout(() => {
      setShowClear(false);
      onClear();
      // onsearchTermChange(e, selectedCategory)
    }, 50);
  };
  (0, _react.useEffect)(() => {
    if (filterType) {
      setFilterTypeBool(true);
      setSelectedCategory(filterType);
    }
  }, [filterType]);
  return /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: e => {
      var _e$target$;
      e.preventDefault();
      handleSubmit((_e$target$ = e.target[0]) === null || _e$target$ === void 0 ? void 0 : _e$target$.value, selectedCategory);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "searchbar-wrap searchbar-no-radius searchbar_large d-flex"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _Search.default,
    alt: "search icon",
    role: "presentation",
    width: "24",
    height: "24"
  }), filterTypeBool && filterType ? /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex selected-category-type category-tag justify-content-center align-items-center"
  }, /*#__PURE__*/_react.default.createElement("span", null, filterType), /*#__PURE__*/_react.default.createElement("span", {
    className: "ps-1 clear",
    onClick: clearFilterType
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _Close.default,
    alt: "close-icon",
    width: "18",
    height: "18"
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null), /*#__PURE__*/_react.default.createElement("input", {
    type: "text",
    id: "searchInputFormControl",
    className: "searchbar_control ps-0",
    placeholder: placeHolderData ? placeHolderData : "Search through API Docs, Solutions and more...",
    required: true,
    onChange: e => {
      /* istanbul ignore next */
      onsearchInputChange(e, selectedCategory);
    }
  }), showClear && /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "clear input",
    onClick: clearSearchInput,
    className: "reset-button pe-4",
    type: "reset"
  }, "Clear")));
}
SVBSearchUIBar.propTypes = {
  onsearchTermChange: _propTypes.default.func,
  handleSubmit: _propTypes.default.func,
  onClear: _propTypes.default.func,
  placeHolderData: _propTypes.default.string,
  filterType: _propTypes.default.string
};